import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { LinearGraph, InfoBox } from 'hosman-material';
import { D_TriangleExclamation } from 'hosman-material';

const PriceGraph = ({ sale }) => {
  const [priceSeries, setPriceSeries] = useState([])
  const estimationFolder = sale.estimation_folder

  useEffect(() => {
    estimationFolder.price_data && setPriceSeries([{
      name: 'Prix / m²',
      data: formatSeries(estimationFolder.price_data.points)
    }])
  }, [estimationFolder]);

  const formatSeries = (points) => {
    return points.map((point) => {
      return { x: new Date(point.x).getTime(), y: point.y.values ? Object.values(point.y.values)[0] : point.y.count }
    })
  }

  if (!estimationFolder?.price_data) return null;

  return (
    <div className='flex flex-col gap-6'>
      <p className='h3 text-center text-ih-blue'>Évolution des prix au m² ({sale.property.zip_code})</p>

      <div className='flex flex-col gap-6'>
        {process.env.NODE_ENV !== 'test' &&
          <div className='md:w-1/2 mx-auto'>
            <LinearGraph
              series={priceSeries}
              xAxis={{title: 'Prix / m²',label: '€'}}
            />
          </div>
        }

        <div className='w-3/4 mx-auto'>
          <InfoBox>
            <div className='flex flex-col gap-3'>
              <p>Cette courbe montre l'évolution des prix au m² par trimestre dans votre secteur ({sale.property.zip_code}).</p>

              <div className='flex flex-col md:flex-row gap-3 item-center'>
                <FontAwesomeIcon icon={D_TriangleExclamation} className='text-ih-orange' size='xl' />
                <p>Attention, ces valeurs sont des moyennes calculées à partir des prix de vente de biens ayant des qualités intrinsèques très variées.</p>
              </div>
            </div>
          </InfoBox>
        </div>
      </div>
    </div>
  );
}

export default PriceGraph;

PriceGraph.propTypes = {
  sale: PropTypes.object.isRequired
};
